'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _teamManagementConstants = require('./teamManagementConstants');

var _currentUserConstants = require('../../currentUserConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Initial state
var initialState = Immutable.Map({
    teamMembers: Immutable.OrderedMap(),
    initialIds: Immutable.List()
});

var addTeamMember = function addTeamMember(state, userId) {
    return state.setIn(['teamMembers', userId], Immutable.Map({ userId: userId, state: _teamManagementConstants.TEAM_MEMBER_STATES.ADDED }));
};

var addNewTeamMember = function addNewTeamMember(state, _ref) {
    var userId = _ref.userId,
        valid = _ref.valid;
    return state.setIn(['teamMembers', userId], Immutable.Map({ userId: userId, state: _teamManagementConstants.TEAM_MEMBER_STATES.NEW }));
};

var removeTeamMember = function removeTeamMember(state, userId) {
    var existingMemberState = state.getIn(['teamMembers', userId, 'state']);

    if (existingMemberState === _teamManagementConstants.TEAM_MEMBER_STATES.ADDED) {
        return state.setIn(['teamMembers', userId, 'state'], _teamManagementConstants.TEAM_MEMBER_STATES.REMOVED);
    }

    return state.deleteIn(['teamMembers', userId]);
};

var setTeamMembers = function setTeamMembers(state, userIds) {
    return userIds.reduce(function (acc, userId) {
        return addTeamMember(acc, userId);
    }, initialState).set('initialIds', Immutable.List(userIds));
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _currentUserConstants.CURRENT_USER_SET:
            return addTeamMember(state, action.user._id);
        case _teamManagementConstants.TEAM_MEMBER_ADD_NEW:
            return addNewTeamMember(state, action);
        case _teamManagementConstants.TEAM_MEMBER_ADD:
            return addTeamMember(state, action.userId);
        case _teamManagementConstants.TEAM_MEMBER_REMOVE:
            return removeTeamMember(state, action.userId);
        case _teamManagementConstants.TEAM_MEMBERS_SET:
            return setTeamMembers(state, action.userIds);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/teamManagementModalReducer.js
// module id = 2098
// module chunks = 0